import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { PhotoSize } from '../types';

@Component({
  selector: 'photo-view',
  templateUrl: './photo-view.component.html',
  styleUrls: ['./photo-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoViewComponent {
  @Input() text?: string;
  @Input() photoSrc?: string;
  @Input() size: PhotoSize = 'xxl';
  @Input() width?: string;
  @Input() height?: string;
  @Input() borderRadius?: string;
  @Input() rounded: boolean = false;
  @Input() loading: boolean = false;
  @Input() showPreview: boolean = true;
  @Output() openPreviewDialog = new EventEmitter<void>();

  onClick() {
    if (!this.photoSrc || !this.showPreview) {
      return;
    }

    this.openPreviewDialog.emit();
  }
}
